import React from 'react';
import { ScrollView, View } from 'react-native';

import { MemberCard } from '@/components/domain/members/MemberCard';
import { PostCard } from '@/components/domain/posts/PostCard';
import { Heading } from '@/components/gluestack/heading';
import { HStack } from '@/components/gluestack/hstack';
import { VStack } from '@/components/gluestack/vstack';
import { ScreenHeader } from '@/components/layout/ScreenHeader';
import { NotFoundContent } from '@/components/ui/NotFoundContent';
import { useAuth } from '@/components/providers/AuthProvider';

function isDeveloperTestUser(userName?: string | null): boolean {
  return userName?.toLowerCase().startsWith('testuser') ?? false;
}

// Developer tool: renders the loading skeletons permanently so their look and
// animation can be checked without hunting for an uncached screen.
function SkeletonPreviewContent() {
  return (
    <>
      <ScreenHeader options={{ title: 'Skeleton Preview' }} />
      <ScrollView>
        <VStack className="gap-3 p-3 md:pt-0">
          <Heading size="sm">PostCard</Heading>
          <PostCard />

          <Heading size="sm">MemberCard</Heading>
          <HStack className="gap-3">
            <View className="flex-1">
              <MemberCard />
            </View>
            <View className="flex-1">
              <MemberCard />
            </View>
          </HStack>

          <Heading size="sm">MemberCard (compact)</Heading>
          <HStack className="gap-3">
            <View className="flex-1">
              <MemberCard compact />
            </View>
            <View className="flex-1">
              <MemberCard compact />
            </View>
            <View className="flex-1">
              <MemberCard compact />
            </View>
          </HStack>
        </VStack>
      </ScrollView>
    </>
  );
}

export default function SkeletonPreview() {
  const { accountStatus } = useAuth();

  if (!isDeveloperTestUser(accountStatus?.UserName)) {
    return (
      <>
        <ScreenHeader options={{ title: 'Skeleton Preview' }} />
        <NotFoundContent />
      </>
    );
  }

  return <SkeletonPreviewContent />;
}
